@if (title()) {
  <span mat-dialog-title class="title-medium on-surface-text">{{
    title()
  }}</span>
}

@if (contentTmpl() || contentStr()) {
  <div mat-dialog-content>
    @if (contentTmpl(); as contentTmpl) {
      <ng-container *ngTemplateOutlet="contentTmpl"></ng-container>
    } @else {
      <span class="body-medium on-surface-text">
        {{ contentStr() }}
      </span>
    }
  </div>
}

<div mat-dialog-actions class="align-between">
  @if (leftAction(); as leftAction) {
    @if (leftAction.type === "flat") {
      <button
        mat-flat-button
        [class.error-button]="leftAction.error"
        (click)="handleLeftActionClicked()"
      >
        @if (leftAction.icon) {
          <mat-icon>{{ leftAction.icon }}</mat-icon>
        }
        {{ leftAction.label }}
      </button>
    } @else if (leftAction.type === "stroked") {
      <button
        mat-stroked-button
        [class.error-button]="leftAction.error"
        (click)="handleLeftActionClicked()"
      >
        @if (leftAction.icon) {
          <mat-icon>{{ leftAction.icon }}</mat-icon>
        }
        {{ leftAction.label }}
      </button>
    } @else if (leftAction.type === "raised") {
      <button
        mat-raised-button
        [class.error-button]="leftAction.error"
        (click)="handleLeftActionClicked()"
      >
        @if (leftAction.icon) {
          <mat-icon>{{ leftAction.icon }}</mat-icon>
        }
        {{ leftAction.label }}
      </button>
    } @else if (leftAction.type === "icon") {
      <button
        mat-icon-button
        [class.error-button]="leftAction.error"
        (click)="handleLeftActionClicked()"
      >
        <mat-icon>{{ leftAction.icon }}</mat-icon>
      </button>
    } @else {
      <button
        mat-button
        [class.error-button]="leftAction.error"
        (click)="handleLeftActionClicked()"
      >
        @if (leftAction.icon) {
          <mat-icon>{{ leftAction.icon }}</mat-icon>
        }
        {{ leftAction.label }}
      </button>
    }
  }

  @if (rightAction(); as rightAction) {
    @if (rightAction.type === "flat") {
      <button
        mat-flat-button
        [class.error-button]="rightAction.error"
        (click)="handleRightActionClicked()"
      >
        @if (rightAction.icon) {
          <mat-icon>{{ rightAction.icon }}</mat-icon>
        }
        {{ rightAction.label }}
      </button>
    } @else if (rightAction.type === "stroked") {
      <button
        mat-stroked-button
        [class.error-button]="rightAction.error"
        (click)="handleRightActionClicked()"
      >
        @if (rightAction.icon) {
          <mat-icon>{{ rightAction.icon }}</mat-icon>
        }
        {{ rightAction.label }}
      </button>
    } @else if (rightAction.type === "raised") {
      <button
        mat-raised-button
        [class.error-button]="rightAction.error"
        (click)="handleRightActionClicked()"
      >
        @if (rightAction.icon) {
          <mat-icon>{{ rightAction.icon }}</mat-icon>
        }
        {{ rightAction.label }}
      </button>
    } @else if (rightAction.type === "icon") {
      <button
        mat-icon-button
        [class.error-button]="rightAction.error"
        (click)="handleRightActionClicked()"
      >
        <mat-icon>{{ rightAction.icon }}</mat-icon>
      </button>
    } @else {
      <button
        mat-button
        [class.error-button]="rightAction.error"
        (click)="handleRightActionClicked()"
      >
        @if (rightAction.icon) {
          <mat-icon>{{ rightAction.icon }}</mat-icon>
        }
        {{ rightAction.label }}
      </button>
    }
  }
</div>
